import { render, staticRenderFns } from "./WelfareCouponSelectPop.vue?vue&type=template&id=771c016c&scoped=true"
import script from "./WelfareCouponSelectPop.vue?vue&type=script&lang=ts"
export * from "./WelfareCouponSelectPop.vue?vue&type=script&lang=ts"
import style0 from "./WelfareCouponSelectPop.vue?vue&type=style&index=0&id=771c016c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771c016c",
  null
  
)

export default component.exports